module.exports = __webpack_public_path__ + "img/wh_03.8ba1c0be.png";